// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__32tk7","modalFooterButton":"ModalNotes_modalFooterButton__3auYb"};